<!-- <div class="notification-container">
>>>>>>> refs/remotes/origin/feature/update-version
  <div class="notification-content">
    <div class="notification-header">
      <div class="notification-title">
        <h3>Temrango</h3>
      </div>
      <div class="notification-close">
        <h1>{{ tokenToken }}</h1>
      </div>
  </div>
</div> -->
<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="default"
  color="#05a8db"
  type="pacman"
  [fullScreen]="true">
  <div class="animationLoading">
    <img
      src="assets/img/dashboard/loading.png"
      alt="image-loading"
      srcset=""
      class="rotate-scale-up"/>
    <p>Aguarde...</p>
  </div>
</ngx-spinner>
